import React from 'react';
import { IconName as BoxIconName } from 'boxicons';
import { COLOR_OUTERSPACE, Colors } from '@src/types/colors';
import classNames from 'classnames';
import { getColorClasses } from '@src/utils/colorClasses';
import styles from './BoxIcon.module.scss';

interface BoxIcon {
  name: BoxIconName;
  color?: Colors;
  type?: 'default' | 'solid' | 'logo';
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  rotate?: 'bx-rotate-90' | 'bx-rotate-180' | 'bx-rotate-270';
  flip?: 'bx-flip-horizontal' | 'bx-flip-vertical';
  animation?:
    | 'bx-spin'
    | 'bx-tada'
    | 'bx-flashing'
    | 'bx-burst'
    | 'bx-fade-left'
    | 'bx-fade-right';
  animationHover?:
    | 'bx-spin-hover'
    | 'bx-tada-hover'
    | 'bx-flashing-hover'
    | 'bx-burst-hover'
    | 'bx-fade-left-hover'
    | 'bx-fade-right-hover';
  pull?: 'bx-pull-left' | 'bx-pull-right';
  border?: 'bx-border' | 'bx-border-circle';
  className?: string;
}

const checkType = (type: 'default' | 'solid' | 'logo' | undefined): string => {
  switch (type) {
    case 'solid':
      return 'bxs';
    case 'logo':
      return 'bxl';
    case 'default':
    default:
      return 'bx';
  }
};

const getSizeClass = (
  size: 'xs' | 'sm' | 'md' | 'lg' | 'xl',
  styles: any
): { [x: number]: boolean } => ({
  [styles.xs]: size === 'xs',
  [styles.sm]: size === 'sm',
  [styles.md]: size === 'md',
  [styles.lg]: size === 'lg',
  [styles.xl]: size === 'xl'
});

const BoxIcon: React.FC<BoxIcon> = ({
  name,
  type = 'default',
  size = 'md',
  color = COLOR_OUTERSPACE,
  rotate = '',
  flip = '',
  animation = '',
  animationHover = '',
  pull = '',
  border = '',
  className
}) => (
  <i
    className={classNames(
      `bx ${checkType(
        type
      )}-${name} ${rotate} ${flip} ${animation} ${animationHover} ${pull} ${border}`,
      styles.boxIcon,
      getSizeClass(size, styles),
      getColorClasses(color, styles),
      className
    )}
  />
);

export default BoxIcon;
